<template lang="html">
  <div class="outer-div outer-div-heavy">
    <div class="inner-div">

      <div class="center width_full">
        <h3 class='black-text'>Profile Details</h3>
        <div class="form-group">
          <label for="manufacture">Manufacturer:</label>
          <div>
            <input
              type="text"
              class='dark-grey-text'
              v-model='profile.manufacturer'
              :readonly='true'>
          </div>
        </div>

        <div class="form-group">
          <label for="refName">Representative Name:</label>
          <div>
            <input
              type="text"
              class='dark-grey-text'
              v-model='profile.name'
              :class='{ error: validationMessages.name.length || validationMessages.name.format }'
              @keyup='validator(profile.name, "name")'>
              <div class='error' v-if='validationMessages.name.length'>{{ validationMessages.name.length }}</div>
              <div class='error' v-if='!validationMessages.name.length && validationMessages.name.format'>{{ validationMessages.name.format }}</div>
          </div>
        </div>

        <div class="form-group">
          <label for="repPhone">Representative Phone:</label>
          <div>
            <input
              type="text"
              class='dark-grey-text'
              v-model='profile.phone'
              :class='{ error: validationMessages.phone.length || validationMessages.phone.format }'
              @keyup='validator(profile.phone, "phone")'>
              <div class='error' v-if='validationMessages.phone.length'>{{ validationMessages.phone.length }}</div>
              <div class='error' v-if='!validationMessages.phone.length && validationMessages.phone.format'>{{ validationMessages.phone.format }}</div>
          </div>
        </div>

        <div class="form-group">
          <label for="refEmail">Representative Email:</label>
          <div>
            <input
              type="text"
              class='dark-grey-text'
              v-model='profile.email'
              :class='{ error: validationMessages.email.length || validationMessages.email.format }'
              @keyup='validator(profile.email, "email")'>
              <div class='error' v-if='validationMessages.email.length'>{{ validationMessages.email.length }}</div>
              <div class='error' v-if='!validationMessages.email.length && validationMessages.email.format'>{{ validationMessages.email.format }}</div>
          </div>
        </div>

        <div class="form-group">
          <div class="submit-pane">
            <button
              class='dark-grey-bg width_full'
              :disabled='buttonDisable'
              @click="editDetails">{{text}}
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clone } from '../../Services/objectModifier'
import * as NameSpace from '../../store/NameSpace'
import { mapActions, mapGetters } from 'vuex'
import { validateFields } from 'src/Services/Validation/index'
import { pick } from 'lodash'

export default {
  data () {
    return {
      profile: {
        manufacturer: '',
        name: '',
        phone: '',
        email: ''
      },
      validationMessages: {
        name: {
          length: null,
          format: null
        },
        phone: {
          length: null,
          format: null
        },
        email: {
          length: null,
          format: null
        }
      },
      text: 'Edit to update',
      buttonDisable: true,
      existingProfileData: null
    }
  },
  computed: {
    ...mapGetters({
      computedProfileObject: NameSpace.GET_PROFILE,
      authState: NameSpace.AUTH_GETTER
    }),
    user () {
      return this.authState.auth
    },
    computedProfile () {
      return this.computedProfileObject.profile
    },
    computedProfileErrors () {
      return this.computedProfileObject.error
    }
  },
  watch: {
    computedProfileErrors () {
      if (this.computedProfileObject.error) {
        this.pop({
          header: 'Request Failed',
          message: this.computedProfileErrors,
          type: 'ERROR'
        })
      }
    },
    computedProfile () {
      this.updateAuthUser()
      this.pop({
        header: 'Success',
        message: 'Profile updated successfully',
        type: 'success'
      })
    }
  },
  created () {
    this.profile = pick(clone(this.user), ['manufacturer', 'email', 'phone', 'name'])
    if (this.profile.name === undefined) {
      this.profile.name = ''
    }
    if (this.profile.email === undefined) {
      this.profile.email = ''
    }
    if (this.profile.phone === undefined) {
      this.profile.phone = ''
    }
    this.existingProfileData = clone(this.profile)
  },
  methods: {
    ...mapActions({
      updateProfileData: NameSpace.ACTION_PROFILE,
      updateAuthUser: NameSpace.UPDATE_AUTH_USER_FROM_PROFILE,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION
    }),
    editDetails () {
      this.updateProfileData(this.profile)
    },
    validator (input, type) {
      this.validationMessages[type] = validateFields(input, type)
      this.processButton(type)
    },
    processButton (type) {
      if (type === 'name') {
        if (!this.disableEditButton()) {
          this.syncButton('name')
        } else {
          this.syncButtonText(true, 'Update Profile')
        }
      }
      if (type === 'email') {
        if (!this.disableEditButton()) {
          this.syncButton('email')
        } else {
          this.syncButtonText(true, 'Update Profile')
        }
      }
      if (type === 'phone') {
        if (!this.disableEditButton()) {
          this.syncButton('phone')
        } else {
          this.syncButtonText(true, 'Update Profile')
        }
      }
    },
    disableEditButton () {
      for (let types in this.validationMessages) {
        for (let error in this.validationMessages[types]) {
          if (this.validationMessages[types][error]) {
            return true
          }
        }
      }
      return false
    },
    syncButton (text) {
      if (this.profile[text] !== this.existingProfileData[text]) {
        this.syncButtonText(false, 'Update Profile')
      } else {
        this.syncButtonText(true, 'Edit to update')
      }
    },
    syncButtonText (bool, text) {
      this.buttonDisable = bool
      this.text = text
    }
  }
}
</script>

<style scoped>

.black-text {
  font-size: 2.8rem;
}

label{
  font-size: 1.3rem;
  text-transform: uppercase;
  letter-spacing: .1rem;
  margin: 0 0 0 .2rem;
  color: black;
}

input {
  width: 100%;
  height: 3.5rem;
  background: #eee;
  border: none;
  padding: 0 1rem;
  border-radius: .3rem;
}

input.error {
  border: 1px solid red;
}

div.error {
  color: red;
  font-size: 1.3rem
}

input:focus {
  outline: none;
}

button.dark-grey-bg[disabled="disabled"] {
  background-color: #aaa;
  border: none;
  cursor: not-allowed;
}

.center {
  margin: 0 auto;
  text-align: left;
}

.inline-block {
  padding: 1rem;
  display: inline-block;
}

@media only screen and (min-width: 100px) {
  .outer-div-heavy {
    padding: 3rem 1rem;
  }

  .inner-div {
    padding:5%;
  }
}

@media only screen and (min-width: 1000px) {
  .outer-div-heavy {
    padding: 3.4rem 40rem;
  }

  .inner-div {
    margin: 1rem 1rem;
    padding: 2rem 5rem;
  }
}

.submit-pane {
  margin: .5rem 0;
}

button {
  font-size: 1.2rem;
  margin: 2.2rem 0 0 0;
  border-bottom: .2rem solid black;
  text-transform: uppercase;
  letter-spacing: .1rem;
}

h3 {
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 1rem 0;
  font-weight: normal;
  letter-spacing: .1rem;
}

.form-group {
  margin:1.5rem 0rem 0rem 0rem;
}

</style>



// WEBPACK FOOTER //
// Profile.vue?18609b8e